/* Rquiere de mixin.js */

var ticketMessages = {
	data () {
		return {
			methods: {
				ticketMessageUpdate: 'ticketMessage/update',
			},
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
	},
};

export default ticketMessages;